import { render, staticRenderFns } from "./exam_wp.vue?vue&type=template&id=026d3cb0&scoped=true&"
import script from "./exam_wp.vue?vue&type=script&lang=js&"
export * from "./exam_wp.vue?vue&type=script&lang=js&"
import style0 from "./exam_wp.vue?vue&type=style&index=0&id=026d3cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d3cb0",
  null
  
)

export default component.exports